// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading[data-v-24a16d5c]{position:relative;width:100%;height:100%;background-color:#000;z-index:1}.loading img[data-v-24a16d5c]{position:fixed;left:50%;top:50%;width:20vw;height:20vw;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = exports;
